import { IHousePlanHit } from '@/lib/search/types';
import { OrModelHomeGrid } from './or-model-home-grid';
import { getModelHomes } from '@/lib/data/getStudioModelHomes';
import {
  IOrModelHomeGridCsProps,
  TGroupedHome,
} from './or-model-home-grid.types';
import { getCachedInitialProps } from '@/components/helpers/fetchInitialProps';

export const OrModelHomeGridCs = async ({ block }: IOrModelHomeGridCsProps) => {
  const { studioData: allStudios } = await getCachedInitialProps();

  const modelHomes = await getModelHomes();

  const sortedModelHomes = modelHomes.slice().sort((a, b) => {
    if (a.Name < b.Name) return -1;
    if (a.Name > b.Name) return 1;
    return 0;
  });

  const groupedModelHomes = sortedModelHomes.reduce(
    (result: TGroupedHome, item: IHousePlanHit) => {
      const planName = item.Plan.Name;
      if (!result[planName]) {
        result[planName] = [];
      }
      result[planName].push(item);
      return result;
    },
    {},
  );

  return (
    <OrModelHomeGrid
      allDesignStudios={allStudios}
      headingElement={block?.heading_element.select}
      modelHomeData={groupedModelHomes}
      topSpacing={block?.top_spacing?.spacing_value}
      bottomSpacing={block?.bottom_spacing?.spacing_value}
      topDivider={block?.top_spacing?.divider}
      bottomDivider={block?.bottom_spacing?.divider}
    />
  );
};
